<template>
  <div>
    <KTCard ref="preview" v-bind:title="'Add new'">
      <template v-slot:title>
        <h3 class="card-label">
          <router-link :to="{ name: 'list-stores' }">{{
            $t("STORES")
          }}</router-link>
          <i class="mr-2"></i>
          <small class="">{{ $t("ADD_NEW") }}</small>
        </h3>
      </template>
      <template v-slot:toolbar>
        <div class="example-tools justify-content-center">
          <BackButton></BackButton>
          <SaveButtonDropdown
            :isLoading="isLoadingStore"
            v-on:save="onSave($event)"
          ></SaveButtonDropdown>
        </div>
      </template>
      <template v-slot:body>
        <b-form>
          <FormBuilder
            v-if="!firstLoader"
            :form="form"
            :schemaJson="schemaJson"
            :v="$v"
          ></FormBuilder>
          <SkeletonLoaderMain :visible="firstLoader"></SkeletonLoaderMain>
          <v-overlay :value="!firstLoader && isLoadingStore">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </b-form>
      </template>
      <template v-slot:foot>
        <div
          v-show="_.size(errors) > 0"
          role="alert"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
      </template>
      <template v-slot:toolbarfoot>
        <div class="example-tools justify-content-center">
          <BackButton></BackButton>
          <SaveButtonDropdown
            :defaultAction="'exit'"
            :isLoading="isLoadingStore"
            v-on:save="onSave($event)"
          ></SaveButtonDropdown>
        </div>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SAVE_STORE } from "@/modules/store/store/store.module";

//City Module
import { FETCH_CITIES } from "@/modules/city/store/city.module";

import FormBuilder from "@/view/content/forms/FormBuilder.vue";

import SaveButtonDropdown from "@/view/content/forms/components/SaveButtonDropdown.vue";

import { validationMixin } from "vuelidate";

import { formBuilderMixin } from "@/core/mixins/formBuilderMixin.js";

import KTCard from "@/view/content/Card.vue";
import { mapGetters, mapState } from "vuex";

export default {
  mixins: [validationMixin, formBuilderMixin],
  data() {
    return {
      errors: {},
      firstLoader: true,
      store: {},
      cities: [],
      citiesParams: {
        page: 1,
        itemsPerPage: 50,
        query: ""
      }
    };
  },
  components: {
    KTCard,
    FormBuilder,
    SaveButtonDropdown
  },
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Stores", route: { name: "list-stores" } },
      { title: "Edit Store" }
    ]);
    vm.generateFormOutOfSchemaJson(this.schemaJson);
    vm.getCities();
  },
  watch: {},
  computed: {
    ...mapGetters(["isLoadingStore", "currentUser"]),
    ...mapState({
      errors: state => state.auth.errors
    }),
    schemaJson() {
      return {
        fields: [
          {
            type: "switch",
            groupId: "item-isWarehouse-group",
            id: "item-isWarehouse-input",
            inputType: "checkbox",
            feedback_id: "isWarehouse-live-feedback",
            colSm: "auto",
            divider: true,
            default: false,
            i18n: {
              label: "IS_WAREHOUSE",
              placeholder: "IS_WAREHOUSE"
            },
            validations: {
              required: true
            },
            model: "isWarehouse"
          },
          {
            type: "input",
            inputType: "text",
            id: "store-name-input",
            groupId: "store-name-group",
            required: "required",
            feedback_id: "store-live-feedback",
            divider: false,
            i18n: {
              label: "NAME",
              placeholder: "NAME",
              validation: "VALID_NAME"
            },
            validations: {
              required: true,
              minLength: 2
            },
            translatable: false,
            model: "name"
          },
          {
            type: "input",
            inputType: "text",
            id: "store-address-input",
            groupId: "store-address-group",
            required: "required",
            feedback_id: "store-live-feedback",
            divider: false,
            i18n: {
              label: "ADDRESS",
              placeholder: "ADDRESS",
              validation: "VALID_ADDRESS"
            },
            validations: {
              required: true,
              minLength: 2
            },
            translatable: false,
            model: "address"
          },
          {
            type: "select",
            inputType: "select",
            groupId: "store-city-group",
            id: "store-city-input",
            feedback_id: "city-live-feedback",
            divider: true,
            clearable: false,
            i18n: {
              label: "CITY",
              placeholder: "CITY",
              validation: "VALID_CITY"
            },
            options: this.cities,
            validations: {
              required: true
            },
            model: "cityId"
          },
          {
            type: "input",
            inputType: "text",
            id: "store-code-input",
            groupId: "store-code-group",
            required: "required",
            feedback_id: "store-live-feedback",
            divider: false,
            i18n: {
              label: "CODE",
              placeholder: "CODE",
              validation: "CODE"
            },
            validations: {
              required: true,
              minLength: 2
            },
            translatable: false,
            model: "code"
          }
        ]
      };
    }
  },
  methods: {
    getCities(search, loading = function() {}) {
      let vm = this;
      let params = this.citiesParams;
      let apiParams = vm.transformUrlParams(params);
      this.$store
        .dispatch(FETCH_CITIES, apiParams)
        .then(data => {
          if (data.data.items.length) {
            vm.cities = data.data.items;
            vm.totalCities = data.data.totalItemsCount;
            vm.$set(vm.form, "cityId", vm.cities[0].id);
            vm.firstLoader = false;
          }
        })
        .catch(response => {
          console.log(response);
        })
        .finally(() => {
          loading(false);
        });
    },
    transformUrlParams(params) {
      let apiParams =
        "?" +
        Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");
      return apiParams;
    },
    onSubmit(evt) {
      evt.preventDefault();
    },
    onSave(next) {
      let vm = this;
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        vm.$notify({
          group: "notify",
          type: "error",
          title: "<i class='flaticon-close'></i> Warning",
          text: "Please fill all required fields correctly"
        });
        return;
      }
      this.$store
        .dispatch(SAVE_STORE, this.form)
        .then(data => {
          let itemEdit = data.data;
          vm.$notify({
            group: "notify",
            type: "success",
            title: "<i class='flaticon2-checkmark'></i> Success",
            text: data.message
          });
          // let itemEdit = data.data;
          if (next == "continue") {
            //New
            this.$router.push({
              name: "edit-store",
              params: { id: itemEdit.id }
            });
          }
          if (next == "new") {
            //New
            this.$router.push({ name: "add-store" });
          }
          if (next == "exit") {
            this.$router.push({ name: "list-stores" });
          }
        })
        .catch(function(response) {
          vm.errors = response.data.errors;
          vm.$notify({
            group: "notify",
            type: "error",
            title: "Error",
            text: response.data.message
          });
        });
    },
    resetVForm() {
      this.$v.$reset();
    }
  }
};
</script>
